Namespace 'CustomerVisualMode.Filters.LastInterval.Converters'

class CustomerVisualMode.Filters.LastInterval.Converters.MonthConverter
  constructor: ->
    @aMonthInSeconds = moment.duration(1, 'months').asSeconds()

  toSeconds: (month) ->
    {
      name: @_label(month)
      interval: @_monthInSeconds(month)
    }

  canConvert: (seconds) ->
    (seconds % @aMonthInSeconds) == 0

  getLabelFromSeconds: (seconds) ->
    months = Math.round(moment.duration(seconds, 'seconds').asMonths())
    @_label(months)

  _monthInSeconds: (month) ->
    moment.duration(month*30, 'days').asSeconds()

  _label: (month) ->
    I18n.t('customer_visual_mode.filters.date.last_interval.month', count: month)
